export default __webpack_public_path__ + "static/media/Ellipse4.305881ff.svg";